import "./OurOffices.css";

const OurOffices = ({ data }: { data: any }) => {
  return (
    <section className="offices-section">
      <div className="offices-container max-w-screen-xl mx-auto px-4 py-10">
        {data?.offices.map((office: any, index: number) => (
          <div key={office.id} className="office-card">
            <img
              src={office?.image}
              alt={office?.country}
              className="office-image"
            />
            <div className="office-info">
              <div className="office-number">
                {office?.id?.toString().padStart(2, "0")}
              </div>
              <div>
                <h3 className="office-country">{office?.country}</h3>
                <p className="office-address">{office?.address}</p>
              </div>
            </div>
            {index < data?.offices.length - 1 && <div className="vertical-divider" />}
          </div>
        ))}
      </div>
    </section>
  ); 
};

export default OurOffices;
